import React, { useEffect } from 'react';
import { ThemeToggle } from '@/components/ThemeToggle';
import { useTheme } from '@/contexts/ThemeContext';
import { trpc } from '@/lib/trpc';

interface Props {
  cartId: number;
  token: string;
}

export const GalleryThemeToggle: React.FC<Props> = ({ cartId, token }) => {
  const { theme, toggleTheme } = useTheme();
  const { data: prefs } = trpc.gallery.getPreferences.useQuery({ cartId, token }, { enabled: !!cartId && !!token });
  const setThemeMutation = trpc.gallery.setTheme.useMutation();

  // On initial prefs load, if server theme differs, apply it locally
  useEffect(() => {
    if (prefs?.theme && prefs.theme !== theme && toggleTheme) {
      // Force theme by directly setting class + localStorage
      const root = document.documentElement;
      if (prefs.theme === 'dark') {
        root.classList.add('dark');
        localStorage.setItem('theme', 'dark');
      } else {
        root.classList.remove('dark');
        localStorage.setItem('theme', 'light');
      }
    }
  }, [prefs?.theme]);

  const handleToggle = () => {
    if (!toggleTheme) return;
    const next = theme === 'light' ? 'dark' : 'light';
    toggleTheme();
    setThemeMutation.mutate({ cartId, token, theme: next });
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className="inline-flex items-center justify-center w-10 h-10 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition"
      title={theme === 'light' ? 'Dark mode' : 'Light mode'}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
};

export default GalleryThemeToggle;
